/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Context_HeadingInputs */

const en_us2_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Context`)
};

const pt_br2_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto`)
};

const es_419_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto`)
};

const pt_pt2_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexto`)
};

const fr_fr2_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contexte`)
};

const de_de2_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontext`)
};

const it_it2_coach_context_heading = /** @type {(inputs: Coach_Context_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contesto`)
};

/**
* | output |
* | --- |
* | "Context" |
*
* @param {Coach_Context_HeadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_context_heading = /** @type {((inputs?: Coach_Context_HeadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Context_HeadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_context_heading(inputs)
	if (locale === "es-419") return es_419_coach_context_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_context_heading(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_context_heading(inputs)
	if (locale === "de-DE") return de_de2_coach_context_heading(inputs)
	if (locale === "it-IT") return it_it2_coach_context_heading(inputs)
	return en_us2_coach_context_heading(inputs)
});
export { coach_context_heading as "coach.context_heading" }